<template>
  <div>
    <h4 class="font-weight-bold"><i class="fas fa-university fa-lg mr-2 text-primary"></i>Select Account <div class="float-right" v-if="bank_discount_percent">
          Pay using bank account for {{ bank_discount_percent }}% discount</div></h4>
    <hr class="mt-1 mb-2" />
    <div class="card-item form-check" v-for="bank in banks" :key="bank.id">
      <input type="radio" name="payment_method" class="form-check-input" :id="bank.id" :value="bank.id" v-model="form.stripe_payment_method" @change="setPayment($event, bank.id)"/>
      <label :for="bank.id">{{ bank.bank_name }} ending in {{ bank.last4 }}</label>

      <div class="float-right" v-if="has_linked">
        
        <label for="allow_payment_switch">Share with My Trucks</label>
        <InputSwitch v-model="bank.mtd_shared_stripe_share_this_method" inputId="allow_payment_switch" @change="toggleShared(bank)"/> 
      </div>
      <div class="float-right" v-else-if="bank.mtd_shared_stripe_share_this_method">Shared</div>
      <div v-if="canDelete && !bank.mtd_shared_stripe_share_this_method" class="float-right">
        <button :disabled="bankProcessing" class="btn btn-link p-0 text-secondary" @click="deleteBank(bank)"><i class="text-gray item-icon fas fa-trash ml-3"></i></button>
      </div>
    </div>
    <div v-if="plaidError" @click="reloadPlaid" class="alert alert-warning my-2 d-flex align-items-center cursor-pointer">
      <i class="fas fa-redo-alt mr-3"></i>
      <p class="mb-0 text-size-small text-dark">There was an error trying to load bank information, would you like to <span class="text-underline text-primary">try again?</span></p>
    </div>
    <jet-add-button :class="{disabled: !canAdd || plaidError}" @click="addBank()">Add Bank</jet-add-button>
  </div>
</template>

<script>
  import JetAddButton from '@/Jetstream/AddButton'
import InputSwitch from 'primevue/inputswitch';

  export default {
    data() {
      return {
        bankProcessing: false,
        plaidError: false
      }
    },
    components: {
      JetAddButton,
      InputSwitch,
    },
    props: {
      banks: Array,
      link_token: String,
      form: Object,
      form_bank: Object,
      bankRoute: String,
      canAdd: {
        type: Boolean,
        default: true
      },
      canDelete: {
        type: Boolean,
        default: true
      },
      bank_discount_percent: false,
      has_linked: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      setPayment(e, id) {
        this.$emit('setPayment', e, id)
      },
      deleteBank(bank) {
        this.bankProcessing = true
        this.$inertia.visit(route('cart.deleteMethod', bank), {
          onSuccess: () => this.bankProcessing = false,
          onFinish: () => this.bankProcessing = false,
          preserveScroll: true
        })
      },
      async addBank() {
        if (!window.Plaid) {
          this.plaidError = true
          return
        }

        this.plaidError = false
        
        const handler = Plaid.create({
          token: this.link_token,
          env: this.$page.props.env != 'production' ? 'sandbox' : 'production',
          onSuccess: (public_token, metadata) => {
            this.form_bank.public_token = public_token;
            this.form_bank.account_id = metadata.accounts[0].id

            this.form_bank.post(this.route(this.bankRoute), {
              onSuccess: () => this.$emit('bankAdded')
            })
          },
          onLoad: () => {},
          onExit: (err, metadata) => {},
          onEvent: (eventName, metadata) => {},
          receivedRedirectUri: null,
        });

        handler.open()
      },
      reloadPlaid() {
        window.location.reload()
      },
      toggleShared(bank) {
        this.cardProcessing = true
        this.$inertia.visit(route('mtd.method.toggleshared', bank), {
          onSuccess: () => this.cardProcessing = false,
          onFinish: () => this.cardProcessing = false,
          preserveScroll: true
        })
      }
    }
  }
</script>
